<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight rounded-t-lg"
        color="#DADADA"
        dense
        flat
    >
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1 rounded-b-lg"
    >
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="loadData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import entitled from "@/urls/roles/entitled";
import names_core from "@/modules/core/routers/names";

export default {
  name: "EntitledOrganizationsList",
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список организаций",
      headers: [
        {text: "Полное наименование", value: "full_name", align: "start", sortable: false, width: "30%"},
        {text: "Краткое наименование", value: "short_name", align: "start", sortable: false, width: "20%"},
        {text: "ИНН", value: "inn", align: "start", sortable: false, width: "15%"},
        {text: "Адрес", value: "legal_address", align: "start", sortable: false, width: "25%"}
      ]
    }
  },
  computed: {
    ...mapGetters({
      items: "entitled/getOrganizations",
      count: "entitled/getOrganizationsCount",
      isLoading: "entitled/isLoadingOrganizations"
    })
  },
  watch: {},
  methods: {
    ...mapActions({
      loadOrganizationsList: "entitled/loadOrganizationsList"
    }),
    loadData(url = undefined) {
      this.loadOrganizationsList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    }
  },
  created() {
    if(entitled.ENTITLED.ALLOWED()) {
      this.loadData()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
